// extracted by mini-css-extract-plugin
export default {"footer-signature-wrapper":"footer-signature_footer-signature-wrapper__TIoR9","footer-signature":"footer-signature_footer-signature__OuyU2"};